import '/assets/styles/partials/category-card.scss';
import classNames from 'classnames';

// Partials
import Placeholder from '/views/partials/placeholder';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Link from '@wearetla/tla-essentials-tools/partials/link';

const CategoryCard = ({ category, className }) => {
	if (!category) {
		return (
			<div className={classNames('categorycard placeholder', className)}>
				<div className="categorycard-imagewrap">
					<Placeholder className="categorycard-image" />
				</div>

				<Placeholder className="categorycard-title" />

				<Placeholder className="categorycard-count" />
			</div>
		);
	}

	return (
		<Link
			className={classNames('categorycard', className)}
			href="menuCategory"
			params={{ id: category.id }}
		>
			<div className="categorycard-imagewrap">
				<Img className="categorycard-image" src={category.image} />
			</div>

			<strong className="categorycard-title">{category.title}</strong>

			<span className="categorycard-count">{category.count} Ürün</span>
		</Link>
	);
};

export default CategoryCard;
